module.exports = __webpack_public_path__ + "img/state-weho.4b3d9747.jpg";